//---- components ---------
//---- mixins -------------
//---- services -----------
//---- other --------------
import { defaultMessages, defaultLocale } from '@/app/locales/index.js'
//---- 3rd-parties --------
import merge from "lodash/merge";
import Vue from 'vue';
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const loadedLanguages = [defaultLocale] // our default language that is preloaded
const messages = Object.assign(defaultMessages);

const i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: defaultLocale,
    messages
});

function setI18nLanguage(lang) {
    i18n.locale = lang
    // axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}


// returns a promise to single file or return an empty object if the file doesn't exist
async function dynamicallyLoadBundle(importMethod) {
   try {
        return await importMethod()
   }
   catch (e) {
        // todo, should we warn?
        return {};
   }
}

// this method imports a non-built-in language and takes care or error handling
// when the stock file doesn't exist
async function dynamicLanguageImport(lang) {

   // load these in parallel
   const bundlesToLoad = [dynamicallyLoadBundle(() => import(`@/app/locales/i18n_${lang}.json`)),
                          dynamicallyLoadBundle(() => import(`@/app/customers/locales/i18n_${lang}.json`)),
                          dynamicallyLoadBundle(() => import(`vee-validate/dist/locale/${lang}.json`))];

   const [messages, customMessages, veeValidateMessages] = await Promise.all(bundlesToLoad);
   return {
        messages,
        customMessages,
        veeValidateMessages
   }
}

// See https://kazupon.github.io/vue-i18n/guide/lazy-loading.html
// and https://stackoverflow.com/a/64720952/1401409
export async function loadLanguageAsync(lang) {
    // If the same language
    if (i18n.locale === lang)
        return Promise.resolve(setI18nLanguage(lang))

    // If the language was already loaded
    if (loadedLanguages.includes(lang))
        return Promise.resolve(setI18nLanguage(lang))

    // If the language hasn't been loaded yet
    let {messages, customMessages, veeValidateMessages} = await dynamicLanguageImport(lang);

    let bundle = {};

    // veeValidateMessages first as they should be overwritable 
    if (veeValidateMessages != null) {
        merge(bundle, { validation: { ...veeValidateMessages.messages } })
    }

    if (messages != null) {
        merge(bundle, messages.default)
    }

    if (customMessages != null) {
        merge(bundle, customMessages.default)
    }

    i18n.setLocaleMessage(lang, bundle)
    loadedLanguages.push(lang)
    return setI18nLanguage(lang)
}

export default i18n;